'use client';

import { Button, Card, Icon } from '@/components/core';
import { Trans } from '@lingui/react/macro';
import { useEffect, useState } from 'react';
import { useLocalizedLinks, useMediaQuery } from '@/components/core/hooks';
import { Image } from '@/components/core/components/atoms';
import * as styles from './mobile-download-app.styles';

const MobileDownloadApp = () => {
  const [show, setShow] = useState(false);
  const links = useLocalizedLinks();
  const mediaquery = useMediaQuery();
  useEffect(() => {
    let timeout;
    const showPopup = () => {
      timeout = setTimeout(() => {
        setShow(document.readyState === 'complete' && mediaquery.down('md'));
      }, 1500);
    };
    if (document.readyState === 'complete') {
      showPopup();
    }
    window.document.addEventListener('readystatechange', showPopup);
    return () => {
      window.document.removeEventListener('readystatechange', showPopup);
      clearTimeout(timeout);
    };
  }, [mediaquery]);
  if (!show) {
    return null;
  }
  return (
    <Card className={styles.root}>
      <div className={styles.image}>
        <Image src="/download-app/default-mobile.png" alt="download" />
      </div>
      <div className={styles.description}>
        <Trans>Discover new recommendations everyday</Trans>
      </div>
      <span className={styles.download}>
        <Button size="small" as="a" href={links.downloadApp()}>
          <Trans>Download app</Trans>
        </Button>
      </span>
      <span
        role="button"
        tabIndex={0}
        onClick={(evt) => {
          evt.stopPropagation();
          evt.bubbles = false;
          setShow(false);
        }}
        className={styles.closeBtn}
      >
        <Icon name="close" />
      </span>
    </Card>
  );
};

export default MobileDownloadApp;
